import { render } from "./TestPage3.vue?vue&type=template&id=5119ceda&scoped=true"
import script from "./TestPage3.vue?vue&type=script&lang=js"
export * from "./TestPage3.vue?vue&type=script&lang=js"

import "./TestPage3.vue?vue&type=style&index=0&id=5119ceda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5119ceda"]])

export default __exports__